// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fQ","advertDetailService__price":"c-o_fR"};